import { MapContext } from 'components/Mapbox/Mapbox'
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect } from 'react'

export const FitBounds = ({
  bounds,
  duration = 500,
  padding = 100,
}: {
  bounds: [[number, number], [number, number]]
  duration?: number
  padding?: number | mapboxgl.PaddingOptions
}) => {
  var context = useContext(MapContext)

  useEffect(() => {
    if (!context.map) return
    context.map.fitBounds(bounds, {
      padding,
      duration,
    })
    context.map.once('idle', () => {
      if (!context.map) return
      context.map.fitBounds(bounds, {
        padding,
        duration,
      })
    })
  }, [bounds, context.map])

  return null
}
